const products = [
  {
    id: 1,
    name: "MELA VPN",
    tagline: "Privacy & Security",
    description:
      "A powerful VPN solution engineered for iOS, providing encrypted connections, anonymous browsing, and seamless protection across all networks — public or private.",
    features: [
      "End-to-end encryption",
      "Zero-log policy",
      "Global server coverage",
      "Automatic kill switch",
    ],
    icon: "ri-shield-keyhole-line",
    image:
      "https://public.readdy.ai/ai/img_res/dfb76fe44c1c4ef467792752d670c1d0.jpg",
    badge: "iOS",
  },
  {
    id: 2,
    name: "MELA Cleaner",
    tagline: "Performance Optimizer",
    description:
      "An intelligent device cleaner tailored for iOS, freeing up storage, eliminating junk files, and optimizing device performance for a faster, smoother mobile experience.",
    features: [
      "Smart junk detection",
      "Duplicate photo finder",
      "Storage analyzer",
      "Memory optimizer",
    ],
    icon: "ri-sparkling-2-line",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20cleaner%20optimization%20icon%20glowing%20emerald%20green%20rays%20on%20dark%20background%20minimal%20clean%20tech%20art%20digital%20performance%20concept%20no%20text%20elegant%20gradient%20dark%20matte%20surface%20professional%20app%20icon%20style&width=600&height=400&seq=cleaner-product-card-01&orientation=landscape",
    badge: "iOS",
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="w-full bg-[#0f1117] py-32 px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-20">
          <span className="inline-block text-[#2dd4bf] text-xs tracking-[4px] uppercase font-medium mb-4">
            Our Products
          </span>
          <h2 className="text-4xl md:text-5xl font-thin text-white leading-tight">
            Crafted for <span className="font-semibold text-white">iOS Excellence</span>
          </h2>
          <p className="text-white/50 mt-4 text-base max-w-lg mx-auto">
            Two focused applications — each solving a critical need for mobile users.
          </p>
        </div>

        {/* Product Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {products.map((product) => (
            <div
              key={product.id}
              className="group bg-[#1a1d26] rounded-2xl overflow-hidden border border-white/5 hover:border-[#2dd4bf]/30 transition-all duration-500"
            >
              {/* Image */}
              <div className="relative w-full h-56 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1a1d26] via-transparent to-transparent" />
                <span className="absolute top-4 left-4 text-xs font-medium text-[#2dd4bf] bg-[#2dd4bf]/10 border border-[#2dd4bf]/30 px-3 py-1 rounded-full">
                  {product.badge}
                </span>
              </div>

              {/* Content */}
              <div className="p-8">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#2dd4bf]/10">
                    <i className={`${product.icon} text-[#2dd4bf] text-xl`} />
                  </div>
                  <div>
                    <h3 className="text-white font-semibold text-xl">{product.name}</h3>
                    <span className="text-[#2dd4bf] text-xs tracking-wider uppercase">{product.tagline}</span>
                  </div>
                </div>

                <p className="text-white/55 text-sm leading-relaxed mb-6">
                  {product.description}
                </p>

                <ul className="grid grid-cols-2 gap-2">
                  {product.features.map((feat) => (
                    <li key={feat} className="flex items-center gap-2 text-white/60 text-sm">
                      <i className="ri-check-line text-[#2dd4bf] text-base" />
                      {feat}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
